import { authApiHandler } from '../services/authApi'
import type { AuthConfig } from '../types/types'
import cookieHandler from '../handlers/cookieHandler'
import tokenHandler from '../handlers/tokenHandler'

export default (config: AuthConfig, cookieHeader?: string) => {
  const cookies = cookieHandler(cookieHeader)
  const token = tokenHandler(config)
  const authApi = authApiHandler(config)

  return async (): Promise<string | null> => {
    const provider = cookies.getProvider()
    const idToken = cookies.getIdToken()
    const refreshToken = cookies.getRefreshToken()
    let accessToken = cookies.getAccessToken()
    const isPunchout = provider === 'dustin_punchout'
    const isValidIdToken = token.isValidToken(idToken)

    const selectedContactId = cookies.getContactId()

    if (!isValidIdToken) {
      if (!refreshToken) {
        cookies.clearTokens()
        return null
      }

      if (!provider) {
        cookies.clearTokens()
        return null
      }

      const tokens = await authApi.refreshTokens(refreshToken, provider, selectedContactId)

      if (!tokens) {
        // Guard: a concurrent refresh may have already updated the cookies.
        // Re-read the ID token and check validity before clearing.
        const currentIdToken = cookies.getIdToken()
        if (token.isValidToken(currentIdToken)) {
          return cookies.getAccessToken()
        }
        cookies.clearTokens()
        return null
      }

      cookies.setIdToken(tokens.idToken, isPunchout)
      cookies.setRefreshToken(tokens.refreshToken, isPunchout)
      cookies.setAccessToken(tokens.micrositeToken, isPunchout)

      return tokens.micrositeToken
    }

    const isValidAccessToken = token.isValidToken(accessToken)

    if (isValidAccessToken) {
      return accessToken
    }

    accessToken = await authApi.getAccessToken(idToken, selectedContactId)

    if (!accessToken) {
      cookies.clearTokens()
      return null
    }

    cookies.setAccessToken(accessToken, isPunchout)

    return accessToken
  }
}
